import { UserProfileType } from 'src/app/modules/login/services/user-api.service';

export const constants = {
  requestTimeBeforeSpinner: 50,
  tableColumnTextLimit: 150,
  urlsForNonBlockingSpinner: [
    {
      url: 'generate',
      method: 'GET',
    },
  ],
  urlsForNoSpinner: [
    {
      url: 'documents',
      method: 'POST',
    },
    {
      url: 'FileUpload',
      method: 'POST',
    },
    {
      url: 'workspaces',
      method: 'PUT',
    },
    {
      url: 'workspaces',
      method: 'POST',
    },
    {
      url: 'workspace-analysis',
      method: 'POST',
    },
    {
      url: 'page-review',
      method: 'GET',
    },
    {
      url: 'documentGeneration/generate-clause-list',
      method: 'POST',
    },
  ],
  delayBetweenGetPagedReviewData: 5,
  tooltipHideDelay: 300,
  notificationHideDelay: 5000,
  notificationGenerateDocumentHideDelay: 20000, // to have ability click download and|or view document link
  notificationInfinityHideDelayKeyValue: 99999,
  defaultDataTablePageLength: 10,
  fileUploaderAcceptedFormats: ['.docx', '.pdf'],
  baselineDocsFileUploaderAcceptedFormats: ['.docx', '.pdf'],
  adminOnly: [UserProfileType.Admin],
  adminAndLegal: [UserProfileType.Admin, UserProfileType.Legal],
  salesAndProcurement: [UserProfileType.Sales, UserProfileType.Procurement],
  allAvailableRoles: [
    UserProfileType.Admin,
    UserProfileType.Legal,
    UserProfileType.Sales,
    UserProfileType.Procurement,
  ],
  fileUploaderAcceptedFormatsTypes: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
  ],
  supportEmail: 'support@autolex.ai',
  supportUrl: 'https://www.autolex.ai/support',
  authTypeKey: 'AUTH_TYPE',
  drawer: {
    documentsWidth: '33vw',
    masterClauseWidth: '33vw',
    maxWidth: '33vw',
  },
  fields: {
    documentId: 'uniqueId',
    documentType: 'type',
    documentUserPosition: 'userPositionId',
    documentCounterparties: 'parties',
    documentStatus: 'status',
    documentLanguage: 'languageId',
    clauseId: 'uniqueId',
    clauseDocumentTypes: 'documentTypes',
    clauseUserPositions: 'positions',
    clauseLanguage: 'languageId',
    questionId: 'id',
    questionDocumentTypes: 'documentTypes',
    questionUserPositions: 'positions',
    questionLanguage: 'languageId',
  },
  icons: {
    greenTick: '<span class="icon-check green"></span>',
    redCross: '<span class="icon-close red"></span>',
    link: '<span class="icon-link"></span>',
    signature: '<span class="icon-signature"></span>',
  },
};

export const ALL_DROPDOWN_ITEM = { id: 'ALL', name: 'All' };
